import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyDR6am_c9JPUvbrWgyr0-jikLvyWPpBo_M",
    authDomain: "nsiic-evaluation.firebaseapp.com",
    projectId: "nsiic-evaluation",
    storageBucket: "nsiic-evaluation.firebasestorage.app",
    messagingSenderId: "372847534542",
    appId: "1:372847534542:web:36ecd34f01f15911fb8b9f",
    measurementId: "G-8PJEEVKBHH"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Emulator setup for development
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
    try {
        connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
        connectFirestoreEmulator(db, 'localhost', 8080);
        connectFunctionsEmulator(functions, 'localhost', 5001);
    } catch (error) {
        // Emulator already connected
    }
}

export default app;
